import { render, staticRenderFns } from "./ViewResellerInvoiceComponent.vue?vue&type=template&id=bcebbbde&"
import script from "./ViewResellerInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./ViewResellerInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports